"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var styles_1 = require("@material-ui/core/styles");

var util_1 = require("./styles/util");

var functions_1 = require("./libUtils/functions");

var styles = function styles(theme) {
  return {
    root: function root(props) {
      var rootStyles = {
        color: '',
        backgroundColor: '',
        border: '',
        boxShadow: '',
        opacity: ''
      };

      if (props.color === 'error') {
        if (props.variant === 'outlined') {
          rootStyles.color = theme.palette.error.main;
          rootStyles.backgroundColor = 'transparent';
          rootStyles.border = "1px solid " + theme.palette.error.main;
          rootStyles['&:hover'] = {
            border: "1px solid " + theme.palette.error.main,
            color: theme.palette.error.main,
            backgroundColor: 'rgba(200, 6, 0, 0.1)'
          };
          rootStyles['&:focus'] = {
            boxShadow: "0 0 0 2px " + theme.palette.error.main
          };
        } else if (props.variant === 'text') {
          rootStyles.color = theme.palette.error.main;
          rootStyles.backgroundColor = 'transparent';
          rootStyles['&:hover'] = {
            color: theme.palette.error.main,
            backgroundColor: 'rgba(200, 6, 0, 0.1)'
          };
        } else {
          rootStyles.color = 'white';
          rootStyles.backgroundColor = theme.palette.error.main;
          rootStyles['&:hover'] = {
            backgroundColor: theme.palette.error.dark
          };
          rootStyles['&:focus'] = {
            boxShadow: "0 0 0 4px " + theme.palette.error.dark
          };
        }
      }

      return rootStyles;
    }
  };
};

var MuiButtonWithOverrides = styles_1.withStyles(styles, {
  withTheme: true
})(function (props) {
  var color = props.color,
      rest = __rest(props, ["color"]);

  if (color !== 'error') {
    rest['color'] = color;
  }

  return React.createElement(Button_1.default, Object.assign({}, rest));
});

var Button = function Button(_a) {
  var className = _a.className,
      color = _a.color,
      margin = _a.margin,
      variant = _a.variant,
      active = _a.active,
      isActive = _a.isActive,
      setActiveButton = _a.setActiveButton,
      index = _a.index,
      onClick = _a.onClick,
      props = __rest(_a, ["className", "color", "margin", "variant", "active", "isActive", "setActiveButton", "index", "onClick"]);

  var _React$useState = React.useState(active),
      displayActive = _React$useState[0],
      setActive = _React$useState[1];

  React.useEffect(function () {
    if (active === undefined || displayActive !== isActive) {
      setActive(isActive);
    }
  }, [isActive]);

  var handleButtonGroupClick = function handleButtonGroupClick(el) {
    if (typeof index === 'number' && setActiveButton) {
      setActiveButton(index);
    }

    if (onClick) {
      onClick(el);
    }
  };

  var activeClass = displayActive ? 'UnifiButtonGroup-active' : '';
  var classes = clsx_1.default(className, util_1.createMarginClassNames({
    margin: margin
  }), activeClass);
  var unifiButtonDefaultVariant = variant || 'contained';
  var convertColor = functions_1.convertNeutralColor(color, 'primary');
  return React.createElement(MuiButtonWithOverrides, Object.assign({
    disableFocusRipple: true
  }, props, {
    onClick: handleButtonGroupClick,
    className: classes,
    variant: unifiButtonDefaultVariant,
    color: convertColor
  }));
};

exports.default = Button;